'use strict';

var module = angular.module('doclr.components.adminagendacomponents');

module.directive('invoerenKnop', function ($state, slicesService) {
    return {
        templateUrl: '/partials/adminagenda/invoerenknop.html',
        scope: true,
        link: function ($scope) {
            function stateParams() {
                var criteria = slicesService.slicesLoader.criteria;
                return {
                    dagClicked: criteria.dag,
                    uur: moment({hour: moment().hours() + 1, minutes: 0}).format('HH:mm'),
                    agenda: criteria.agendaOrResource ? encodeURIComponent(criteria.agendaOrResource.id) : null
                };
            }

            $scope.maakAantekening = function () {
                $state.go('.aantekeningmaken', stateParams());
            };
        }
    };
});

module.directive('moveWidget', function () {
    var agendaContextCtrl = null;

    return {
        restrict: 'A',
        scope: {
            agendas: '='
        },
        require: '^agendaContext',
        templateUrl: '/partials/adminagenda/movewidget.html',
        controller: function ($scope, moveService, notificationService, $timeout, slicesService) {
            moveService.registerStartMovingListener(function (afspraak) {
                agendaContextCtrl.activateProfile({
                    maskOnHover: true,
                    clickedInSliceListener: function (slice, uur, event) {
                        if (slice.resource) {
                            return;
                        }

                        moveService.setTarget({dag: slice.dag, van: uur, agendaId: slice.id});
                        $scope.conflictingResources = [];
                        $scope.checkingResources = true;
                        var checkTarget = buildCheckTarget(moveService.getTarget(), moveService.getSelectedDuur());
                        moveService.getAfspraak().verplaatsCheck(checkTarget)
                            .then(conflicting => {
                                $scope.conflictingResources = conflicting;
                            })
                            .catch(() => {
                                $scope.conflictingResources = [];
                            })
                            .finally(() => {
                                $scope.checkingResources = false;
                            });
                        $('.js-showable-movetargetpopover').css({top: event.pageY, left: event.pageX});
                        $timeout(function () {
                            $('.js-showable-movetargetpopover').popover('show');
                        }, 0, false);
                    },
                    clickedOnEventListener: function (event, $event) {
                        moveService.setTarget({
                            dag: event.dag,
                            van: event.van,
                            tot: event.tot,
                            agendaId: event.agendaId,
                            typeId: event.typeId,
                            type: event.type
                        });
                        $scope.conflictingResources = [];
                        $scope.checkingResources = true;
                        var checkTarget = buildCheckTarget(moveService.getTarget(), moveService.getSelectedDuur());
                        moveService.getAfspraak().verplaatsCheck(checkTarget)
                            .then(conflicting => {
                                $scope.conflictingResources = conflicting;
                            })
                            .catch(() => {
                                $scope.conflictingResources = [];
                            })
                            .finally(() => {
                                $scope.checkingResources = false;
                            });
                        $('.js-showable-movetargetpopover').css({top: $event.pageY, left: $event.pageX});
                        $timeout(function () {
                            $('.js-showable-movetargetpopover').popover('show');
                        }, 0, false);
                    },
                    eventInFocus: afspraak
                });
            });
            moveService.registerStopMovingListener(function () {
                agendaContextCtrl.restoreDefaultProfile();
            });

            function buildCheckTarget(target, duur) {
                return {
                    agendaId: target.agendaId,
                    dag: target.dag,
                    van: target.van,
                    duur: duur,
                    tot: moment(target.van, 'HH:mm').add(duur, 'minutes').format('HH:mm')
                };
            }

            $scope.moveService = moveService;
            $scope.getAgendaNaamVan = function () {
                if (moveService.isMoving()) {
                    return $scope.agendas.findAgendaVoorId(moveService.getAfspraak().agendaId).naam;
                }
            };

            $scope.getAgendaNaamNaar = function () {
                if (moveService.hasTarget()) {
                    return $scope.agendas.findAgendaVoorId(moveService.getTarget().agendaId).naam;
                }
            };

            $scope.doMove = function () {
                var copy = moveService.isMakingCopy();
                moveService.doMove().then(function (afspraak) {
                    var actie = (copy ? 'copied' : 'moved');
                    $scope.$emit('afspraak.gewijzigd', 'afspraak ' + actie, afspraak);
                    notificationService.showSuccess(doclrVertaal.instant('notification.appointment.action.' + actie));
                    slicesService.reload();
                });
            };
        },
        link: function ($scope, element, attrs, _agendaContextCtrl) {
            agendaContextCtrl = _agendaContextCtrl;
        },
        replace: false
    };
});

module.directive('dayClickedPopover', function (userContext) {
    var agendaClickListener;
    var isTeleSecretariaat = userContext.isTeleSecretariaat();
    return {
        restrict: 'A',
        templateUrl: '/partials/components/dayclicked.div.html',
        scope: true,
        require: '^agendaContext',
        link: function ($scope, element, attrs, agendaContextCtrl) {
            if (!isTeleSecretariaat) {
                agendaContextCtrl.getDefaultProfile().clickedInSliceListener = agendaClickListener;
            }
        },
        controller: function ($scope, $timeout, $state) {
            agendaClickListener = function (slice, uur, event, userContext) {
                $scope.slice = slice;
                $scope.columnHeader = slice.naam;
                $scope.uur = uur;
                $scope.userContext = userContext;
                $('.js-showable-dayclickedpopover').css({top: event.pageY, left: event.pageX});
                $timeout(function () {
                    $('.js-showable-dayclickedpopover').popover('show');
                }, 0, false);
            };

            $scope.invoeren = function () {
                $state.go('.aantekeningmaken', {
                    dagClicked: $scope.slice.dag,
                    uur: $scope.uur,
                    agenda: encodeURIComponent($scope.slice.id)
                });
            };

            $scope.addAppointment = function () {
                $state.go('.afspraakdetail', {
                    dagClicked: $scope.slice.dag,
                    uur: $scope.uur,
                    agenda: encodeURIComponent($scope.slice.id),
                    //TODO:MUST duur: 15,
                    //TODO:MUST typeId: event.typeId
                })
            };

            $scope.addAbsent = function () {
                $state.go('.afwezigheid', {
                    dagClicked: $scope.slice.dag,
                    uur: $scope.uur,
                    agenda: encodeURIComponent($scope.slice.id)
                })
            };

            $scope.isCalendar = function () {
                return !$scope.slice.resource;
            };

            $scope.isResource = function () {
                return $scope.slice.resource;
            };
        }
    };
});

module.directive('eventClickedPopover', function () {
    let eventClickListener;
    let eventDblClickListener;

    return {
        restrict: 'A',
        templateUrl: '/partials/components/eventclicked.div.html',
        scope: {
            afspraakTypes: '='
        },
        require: '^agendaContext',
        link: function ($scope, element, attrs, agendaContextCtrl) {
            agendaContextCtrl.getDefaultProfile().clickedOnEventListener = eventClickListener;
            agendaContextCtrl.getDefaultProfile().dblClickedOnEventListener = eventDblClickListener;
        },
        controller: function ($scope, $timeout, userContext, $state, popupCloser, AppointmentPopup, appContext) {

            eventClickListener = function (event, $event) {
                event.onResourceCalendar = isAppointmentOnResourceCalendar(event);
                event.isOutlook = isOutlook(event);
                if (event.eventType === 'afspraak' && !event.onResourceCalendar && !event.isOutlook) {
                    AppointmentPopup.openAppointmentPopup(doclrStaticUtils.getUUIDFromUrl(event.id), event);
                } else {
                    if (isAfspraakMogelijkheidVoorTele(event)) {
                        openAfspraakDetail(event);
                    } else {
                        showPopover(event, $event);
                    }
                }
            };

            function isOutlook(event) {
                return event.creatieGebruiker === "Outlook";
            }

            function isAppointmentOnResourceCalendar(event) {
                return !!event.agendaId && appContext.resources.filter(r => r.id === event.agendaId.split("/").pop()).length > 0;
            }

            eventDblClickListener = function (event, $event) {

                if (event.eventType === 'afwezigheid' && event.beschikbaarheidId) {
                    $state.go('.afwezigheid', {
                        absenceId: event.beschikbaarheidId,
                        isPartyAbsence: event.isPartyAbsence,
                        calendarId: event.agendaUuid
                    })
                }

                window.setTimeout(x => {
                    var popover = $('[data-original-title]');
                    if (popover && popover.popover) {
                        popover.popover('hide');
                    }
                }, 10);

                // popupCloser.closeEventPopup($event);
            };

            function showPopover(event, $event) {
                $scope.event = event;
                let popoverClass = $($event.target).hasClass('js-agenda-event-configure-vrijgave') ? '.js-showable-eventvrijgaveclickedpopover' : '.js-showable-eventclickedpopover';
                let popoverElement = $(popoverClass);
                popoverElement.css({top: $event.pageY, left: $event.pageX});
                $timeout(function () {
                    popoverElement.popover('show');
                }, 0, false);
            }

            function isAfspraakMogelijkheidVoorTele(event) {
                return (event.eventType === 'afspraakMogelijkheid' || event.eventType === 'beschikbaarheid')
                    && afspraakToekomst(event) && userContext.isTeleSecretariaat();
            }

            function openAfspraakDetail(event) {
                $state.go('.afspraakdetail', {
                    dagClicked: event.dag,
                    uur: event.van,
                    agenda: encodeURIComponent(event.agendaId),
                    duur: event.duur,
                    typeId: event.typeId
                })
            }
        }
    };
});

module.factory('AppointmentPopup', function ($uibModal, $rootScope) {

    function openAppointmentPopup(appointmentId, event) {

        const scope = $rootScope.$new(true);
        scope.appointmentId = appointmentId;
        scope.event = event;

        scope.modalInstance = $uibModal.open({
            templateUrl: "/partials/components/appointment.details.modal.html",
            controller: appointmentPopupController,
            size: 'lg',
            scope: scope,
            animation: true,
            windowClass: 'appointment-popup'
        });

        scope.modalInstance.result
            .then(angular.noop)
            .catch(angular.noop);

    }

    function appointmentPopupController($scope,
                                        DoclrHttp,
                                        praktijkContext,
                                        appContext,
                                        notificationService,
                                        calendars,
                                        $timeout,
                                        $filter,
                                        $rootScope,
                                        slicesService,
                                        moveService,
                                        Afspraken,
                                        AuditEvents,
                                        printer,
                                        AppointmentLocationProvider,
                                        localStorageService,
                                        BeschikbaarheidTypes,
                                        DoclrModalService,
                                        Resources,
                                        openAppointmentService) {

        const appointmentsUrl = "/api/calendar/v1/party/" + praktijkContext.id + "/appointment";
        const appointmentUrl = appointmentsUrl + "/" + $scope.appointmentId;

        let fadeInCount = 0;


        function fadeInPopup() {
            $timeout(() => {
                var element = document.querySelector(".appointment-popup .modal-content");
                if (element) {
                    element.className = element.className ? element.className + " " + "not-loading" : "not-loading";
                } else {
                    fadeInCount++;
                    if (fadeInCount < 200) {
                        fadeInPopup();
                    }
                }

            }, 5);
        }

        fadeInPopup();

        $scope.loadingData = true;

        $scope.auditEvents = [];

        $scope.showingAuditLog = false;

        $scope.hideAuditLog = function () {
            $scope.showingAuditLog = false;
        }
        $scope.showAuditLog = function () {
            AuditEvents.getForEntityId($scope.appointmentId)
                .then(x => $scope.auditEvents = x.filter(auditEvent => auditEvent.actionType !== 'Update' || hasVisibleDetail(auditEvent)));
            $scope.showingAuditLog = true;
        }

        // An 'Update' whose every detail is filtered out (e.g. the parent-row change dispatched
        // alongside a participant add/remove) would render as an empty "Afspraak aangepast" — drop it.
        function hasVisibleDetail(auditEvent) {
            return (auditEvent.detailsList || []).filter(detail => $scope.shouldShowDetail(detail.fieldName)).length > 0;
        }


        // Structural / derived fields that carry no meaning for a reader of the history.
        const hiddenAuditFields = ['reason', 'id', 'weekday', 'referenceNumber',
            'createOn', 'createUser', 'cancelOn', 'cancelUser', 'hiddenOn', 'hiddenUser',
            'parentAfspraakId', 'participantRole',
            'statusNoShowOn', 'statusNoShowUser', 'statusArrivedOn', 'statusArrivedUser',
            'statusStartedOn', 'statusStartedUser', 'statusEndedOn', 'statusEndedUser'];

        $scope.shouldShowDetail = function (label) {
            if (!label) return false;
            if (hiddenAuditFields.includes(label)) return false;
            // customForm.resourceDetails is an internal mirror — only its readable names are useful
            if (label.indexOf('resources') === 0 && !/resourceName$/.test(label)) return false;

            return true;
        }

        // A calendar change is stored as a bare UUID (calendarId, or a participant add/remove) —
        // resolve it to the calendar name so the history reads like the rest of the screen.
        function resolveAuditValue(value) {
            if (!value) return value;
            const match = calendars.filter(calendar => calendar.uuid === value)[0];
            return match ? match.naam : value;
        }

        $scope.formatAuditValue = function (label, value) {
            if (label === 'calendarId' || label === 'participantCalendarAdded' || label === 'participantCalendarRemoved') {
                return resolveAuditValue(value);
            }
            return value;
        }

        $scope.getAuditLabel = function (label) {
            if (label === 'participantCalendarAdded') return 'Agenda toegevoegd';
            if (label === 'participantCalendarRemoved') return 'Agenda verwijderd';
            if (/resourceName$/.test(label)) return 'Benodigdheid';
            if (label === 'from') return 'Vanaf';
            if (label === 'until') return 'Tot';
            if (label === 'duration') return 'Duur';
            if (label === 'firstName') return 'Voornaam';
            if (label === 'lastName') return 'Achternaam';
            if (label === 'birthDate') return 'Geboortedatum';
            if (label === 'ssin') return 'Rijksregisternummer';
            if (label === 'phoneNumber') return 'Telefoonnummer';
            if (label === 'mail') return 'Email';
            if (label === 'language') return 'Taal';
            if (label === 'calendarId') return 'Agenda';

            if (label.includes('numberOfPersons')) return "Aantal personen";

            if (label.includes('.customFormFields.')) {
                var labelCustomField = label.split('.').pop();
                if (labelCustomField && labelCustomField.length > 0) {
                    return String(labelCustomField).charAt(0).toUpperCase() + String(labelCustomField).slice(1);
                }
                return labelCustomField;
            }

            return label;
        }


        $scope.appContext = appContext;
        $scope.customForm = {fields: []};
        $scope.getListOptions = customFormFactory.getListOptions;
        $scope.fieldConfig = {
            isFirstNameVisible: true,
            isFirstNameRequiredForUser: false,
            isNameVisible: true,
            isNameRequiredForUser: false,
            isPhoneVisible: true,
            isPhoneRequiredForUser: false,
            isSsinVisible: true,
            isSsinRequiredForUser: false,
            isBirthDateVisible: true,
            isBirthDateRequiredForUser: false,
            isMailVisible: true,
            isMailRequiredForUser: false
        };


        function loadCustomForm(appointmentTypeIds) {
            const appointmentTypes = appointmentTypeIds.map(id => doclrUtilsList.getFirst(appContext.appointmentTypes.filter(x => x.id === id)))
                .filter(x => !!x);

            customFormFactory.updateCustomForm(appointmentTypes, $scope.customForm);
            customFormFactory.updateFieldConfig(appointmentTypes, $scope.fieldConfig);

            $scope.appointment.activities.forEach(a => {
                customFormFactory.setValues(a, $scope.customForm);
            });

            customFormFactory.propagateDuplicateValues($scope.customForm);
        }

        $scope.updateAppointment = function () {
            if ($scope.appointment.activities && $scope.activities) {
                customFormFactory.propagateDuplicateValues($scope.customForm);

                $scope.activities.forEach(a => {
                    a.customFormFields = customFormFactory.getValues(a.id, $scope.customForm);
                });

                $scope.appointment.activities = $scope.activities;
                const activityTexts = $scope.appointment.activities.map(a => getActivityText(a));

                const extraReasonValues = $scope.appointment.activities.flatMap(a =>
                    customFormFactory.getExtraReasonValues(a.id, $scope.customForm));
                $scope.appointment.reason = activityTexts.join(", ");

                if (extraReasonValues.length > 0) {
                    $scope.appointment.reason = $scope.appointment.reason + " ; " + extraReasonValues.join(" -- ");
                }

            }

            const hasResources = $scope.appointment.resources &&
                $scope.appointment.resources.resources &&
                $scope.appointment.resources.resources.length > 0;

            $scope.loadingData = true;

            // A duration / time change on the owner also moves the attached colleague rows, so the
            // gekoppelde agenda's must be conflict-checked too — /update-info/check only covers the
            // benodigdheden mirror.
            checkParticipantCalendarsThen(runResourceCheckThenSave);

            function checkParticipantCalendarsThen(next) {
                const slotChanged = !$scope.loadedSlot
                    || $scope.appointment.from !== $scope.loadedSlot.from
                    || $scope.appointment.until !== $scope.loadedSlot.until;

                const participantCalendarIds = ($scope.spanCalendars || [])
                    .filter(participant => participant.role !== 'OWNER')
                    .map(participant => participant.calendarId);

                if (!slotChanged || participantCalendarIds.length === 0) {
                    next();
                    return;
                }

                Resources.checkResourceConflict($scope.appointment.day, $scope.appointment.from, $scope.appointment.until, participantCalendarIds, $scope.appointmentId)
                    .then(result => {
                        const conflicting = (result && result.conflictingResources) || [];
                        if (conflicting.length > 0) {
                            $scope.loadingData = false;
                            DoclrModalService.openConfirmModal(
                                'Agenda niet beschikbaar',
                                'Een of meer gekoppelde agenda’s zijn niet beschikbaar voor het nieuwe tijdstip. Wil je toch verdergaan?'
                            ).then(() => {
                                $scope.loadingData = true;
                                next();
                            }).catch(angular.noop);
                            return;
                        }
                        next();
                    })
                    .catch(() => next());
            }

            function runResourceCheckThenSave() {
                if (hasResources) {
                    DoclrHttp.post(appointmentUrl + "/update-info/check", $scope.appointment)
                        .then(conflicts => {
                            if (conflicts && conflicts.conflictingResources && conflicts.conflictingResources.length > 0) {
                                $scope.loadingData = false;
                                DoclrModalService.openConfirmModal(
                                    'Benodigdheid al bezet',
                                    'Een of meer benodigdheden zijn bezet voor het nieuwe tijdstip. Wil je toch verdergaan?'
                                ).then(() => doUpdateAppointment()).catch(angular.noop);
                                return;
                            }
                            doUpdateAppointment();
                        })
                        .catch(() => {
                            $scope.loadingData = false;
                            notificationService.showDanger("Er is een fout opgetreden. Probeer opnieuw.");
                        });
                } else {
                    doUpdateAppointment();
                }
            }

            function doUpdateAppointment() {
                DoclrHttp.put(appointmentUrl + "/update-info", $scope.appointment)
                    .then(() => notificationService.showSuccess("Afspraak gewijzigd"))
                    .then(() => slicesService.reload())
                    .then(() => $scope.modalInstance.close())
                    .catch(() => {
                        $scope.loadingData = false;
                        notificationService.showDanger("Er is een fout opgetreden. Probeer opnieuw.");
                    });
            }
        }

        $scope.cancelAppointment = function () {
            DoclrModalService.openConfirmModal(
                'Afspraak annuleren',
                'Ben je zeker dat je deze afspraak wil annuleren?'
            ).then(function () {
                $scope.loadingData = true;
                DoclrHttp.post(appointmentUrl + "/cancel")
                    .then(() => notificationService.showSuccess("Afspraak geannuleerd"))
                    .then(() => slicesService.reload())
                    .then(() => $scope.modalInstance.close())
                    .catch(() => $scope.loadingData = false);
            });
        }


        $scope.undoCancelAppointment = function () {
            $scope.loadingData = true;
            DoclrHttp.post(appointmentUrl + "/undo-cancel")
                .then(() => slicesService.reload())
                .then(() => $scope.modalInstance.close())
                .catch(() => $scope.loadingData = false);
        };

        $scope.confirmAppointment = function () {
            DoclrModalService.openConfirmModal(
                'Afspraak bevestigen',
                'Ben je zeker dat je deze afspraak wilt bevestigen?'
            ).then(function () {
                $scope.loadingData = true;
                DoclrHttp.post(appointmentUrl + '/confirm-by-user')
                    .then(() => notificationService.showSuccess('Afspraak bevestigd'))
                    .then(() => $rootScope.$broadcast('notifications:refresh'))
                    .then(() => slicesService.reload())
                    .then(() => $scope.modalInstance.close())
                    .catch(() => {
                        $scope.loadingData = false;
                        notificationService.showDanger('Er is een fout opgetreden. Probeer opnieuw.');
                    });
            }).catch(angular.noop);
        };

        $scope.cancelConfirmedAppointment = function () {
            DoclrModalService.openConfirmWithMessageModal(
                'Afspraak weigeren',
                'Ben je zeker dat je deze afspraak wilt weigeren?'
            ).then(function (message) {
                $scope.loadingData = true;
                DoclrHttp.post(appointmentUrl + '/refuse-by-user', message)
                    .then(() => notificationService.showSuccess('Afspraak geweigerd'))
                    .then(() => $rootScope.$broadcast('notifications:refresh'))
                    .then(() => slicesService.reload())
                    .then(() => $scope.modalInstance.close())
                    .catch(() => {
                        $scope.loadingData = false;
                        notificationService.showDanger('Er is een fout opgetreden. Probeer opnieuw.');
                    });
            }).catch(angular.noop);
        };

        $scope.hideAppointment = function () {
            $scope.loadingData = true;
            DoclrHttp.post(appointmentUrl + "/hide")
                .then(() => slicesService.reload())
                .then(() => $scope.modalInstance.close())
                .catch(() => $scope.loadingData = false);
        };

        $scope.unhideAppointment = function () {
            $scope.loadingData = true;
            DoclrHttp.post(appointmentUrl + "/unhide")
                .then(() => slicesService.reload())
                .then(() => $scope.modalInstance.close())
                .catch(() => $scope.loadingData = false);
        };

        function appointmentLoaded(appointment) {
            $scope.loadingData = false;
            $scope.appointment = appointment;

            // DOCLEAS-042: a participant row (colleague / resource copy) is read-only here — all
            // changes happen on the hoofdafspraak. The template hides the action buttons and shows
            // a "Ga naar hoofdafspraak" link.
            $scope.isParticipantRow = !!appointment.participantRole && appointment.participantRole !== 'OWNER';
            $scope.ownerAppointmentId = $scope.isParticipantRow ? appointment.parentAfspraakId : $scope.appointmentId;
            $scope.isEditCalendars = false;

            // Snapshot of the slot as loaded — used to skip the gekoppelde-agenda conflict check
            // when the duration / time was not touched.
            $scope.loadedSlot = {from: appointment.from, until: appointment.until};

            Afspraken.getParticipants($scope.appointmentId)
                .then(participants => {
                    $scope.spanCalendars = (participants || []).filter(participant => participant.role !== 'RESOURCE');
                    $scope.spanCalendarNames = $scope.spanCalendars
                        .map(participant => participant.calendarName || participant.calendarId)
                        .join(', ');
                })
                .catch(() => {
                    $scope.spanCalendars = [];
                    $scope.spanCalendarNames = '';
                });

            if ($scope.appointment && $scope.appointment.activities) {
                const appointmentTypes = $scope.appointment.activities.map(x => x.id);
                loadCustomForm(appointmentTypes)
            }

            loadCalendar();
            loadActivities();
            loadStatus();
        }

        $scope.goToOwner = function () {
            const ownerId = $scope.appointment.parentAfspraakId;
            $scope.modalInstance.close();
            if (ownerId) {
                openAppointmentService.openAppointment(ownerId, true);
            }
        };

        // DOCLEAS-042: change which calendar is the hoofdafspraak (swap roles with an attached participant)
        $scope.makeThisTheOwner = function () {
            DoclrModalService.openConfirmModal('Hoofdafspraak wijzigen',
                'Deze agenda wordt de hoofdafspraak. De huidige hoofdafspraak wordt een gekoppelde agenda.')
                .then(() => Afspraken.changeOwner($scope.ownerAppointmentId, $scope.appointmentId))
                .then(() => {
                    $scope.modalInstance.close();
                    openAppointmentService.openAppointment($scope.appointmentId, true);
                })
                .catch(angular.noop);
        };

        $scope.makeParticipantTheOwner = function (participant) {
            DoclrModalService.openConfirmModal('Hoofdafspraak wijzigen',
                participant.calendarName + ' wordt de hoofdafspraak. ' + $scope.calendar.naam + ' wordt een gekoppelde agenda.')
                .then(() => Afspraken.changeOwner($scope.appointmentId, participant.appointmentId))
                .then(() => {
                    $scope.modalInstance.close();
                    openAppointmentService.openAppointment(participant.appointmentId, true);
                })
                .catch(angular.noop);
        };

        // DOCLEAS-042: add / remove colleague calendars (owner view only) — mirrors the Benodigdheden picker
        $scope.pickableCalendars = [];

        $scope.changeCalendars = function () {
            // De deelnemerslijst moet geladen zijn, anders wordt een bestaande
            // gekoppelde agenda niet voorgeselecteerd en bij het opslaan weggeschreven.
            if (!$scope.spanCalendars) {
                return;
            }
            const disciplineName = $scope.calendar && $scope.calendar.disciplineName;
            const attached = ($scope.spanCalendars || [])
                .filter(participant => participant.role !== 'OWNER')
                .map(participant => participant.calendarId);

            $scope.pickableCalendars = calendars
                .filter(calendar => !disciplineName || calendar.disciplineName === disciplineName)
                .filter(calendar => calendar.uuid !== $scope.appointment.calendarId)
                .map(calendar => ({
                    calendarId: calendar.uuid,
                    name: calendar.naam,
                    isSelected: attached.includes(calendar.uuid),
                    availableClass: ''
                }));

            checkCalendarAvailability();
            $scope.isEditCalendars = true;
        };

        function checkCalendarAvailability() {
            const calendarIds = $scope.pickableCalendars.map(calendar => calendar.calendarId);
            if (calendarIds.length === 0) {
                return;
            }
            Resources.checkResourceConflict($scope.appointment.day, $scope.appointment.from, $scope.appointment.until, calendarIds, $scope.appointmentId)
                .then(result => {
                    const conflicting = (result && result.conflictingResources) || [];
                    $scope.pickableCalendars.forEach(calendar => {
                        calendar.availableClass = conflicting.includes(calendar.calendarId) ? 'status-nok' : 'status-ok';
                    });
                })
                .catch(angular.noop);
        }

        $scope.cancelCalendars = function () {
            $scope.isEditCalendars = false;
        };

        $scope.saveCalendars = function () {
            const selected = $scope.pickableCalendars
                .filter(calendar => calendar.isSelected)
                .map(calendar => ({calendarId: calendar.calendarId, role: 'REQUIRED'}));

            $scope.loadingData = true;
            Afspraken.updateParticipants($scope.appointmentId, selected)
                .then(() => notificationService.showSuccess('Agenda’s gewijzigd'))
                .then(() => DoclrHttp.get(appointmentUrl))
                .then(appointment => appointmentLoaded(appointment))
                .then(() => slicesService.reload())
                .then(() => $scope.isEditCalendars = false)
                .catch(() => $scope.loadingData = false);
        };

        $scope.copyAppointment = function () {
            moveService.start($scope.event, true);
            $scope.modalInstance.close();
        }

        $scope.moveAppointment = function () {
            moveService.start($scope.event, false);
            $scope.modalInstance.close();
        }

        $scope.printAppointment = function () {
            var afspraak = $scope.event;
            var afspraakId = afspraak.id.split('/').pop();

            Afspraken.getAfspraak(afspraakId).then(function (afspraakDetail) {
                let location = AppointmentLocationProvider.getLocation(praktijkContext, afspraakDetail.typeId);
                printer.printAfspraak(afspraakDetail, praktijkContext, location);
            });
        }

        function loadStatus() {
            $scope.statusInfo = {
                arrived: !!$scope.appointment.statusArrivedOn,
                started: !!$scope.appointment.statusStartedOn,
                ended: !!$scope.appointment.statusEndedOn,
                noShow: !!$scope.appointment.statusNoShowOn,
            };
        }

        $scope.getStatusTrueTooltip = function (statusName, user, date) {
            if (!user || !date) {
                return statusName;
            }
            try {
                return statusName + " - " + $filter('translateUserDisplay')(user) + ' - ' + $filter('easydateUtcToLocal')(date);
            } catch (ex) {
                return statusName;
            }
        }

        $scope.getStatusImageUrl = function imageUrl() {

            const statusInfo = $scope.statusInfo;

            if (statusInfo.noShow) {
                return "noshow.svg";
            }
            if (statusInfo.cancelled) {
                return "cancel.svg";
            }

            if (statusInfo.ended) {
                return "done.svg"
            }

            if (statusInfo.started) {
                return "start.svg";
            }

            if (statusInfo.arrived) {
                return "arrived.svg";
            }
            return "form2.svg"
        }

        $scope.updateStatus = function (statusUrl, isMark) {
            let updateStatusUrl = appointmentUrl + "/status/" + (isMark ? '' : 'undo-') + 'mark-' + statusUrl;
            $scope.loadingData = true;
            DoclrHttp.post(updateStatusUrl)
                .then(x => notificationService.showSuccess("Status aangepast"))
                .then(() => slicesService.reload())
                .catch(angular.noop)
                .finally(() => $scope.loadingData = false);
        }

        $scope.isEditActivity = false;
        $scope.isEditDuration = false;
        $scope.isEditResources = false;
        $scope.pickableResources = [];
        $scope.correlatedPickableResources = [];
        $scope.otherPickableResources = [];

        $scope.editActivities = function () {
            $scope.isEditActivity = true;
        }

        $scope.editDuration = function () {
            $scope.isEditDuration = true;
        }

        $scope.changeBenodigdheid = function () {
            const currentResourceNames = ($scope.appointment.resources && $scope.appointment.resources.resources)
                ? $scope.appointment.resources.resources.map(r => r.resourceName)
                : [];

            $scope.pickableResources = appContext.resources.map(resource => ({
                id: resource.id,
                name: resource.name,
                resourceTypes: resource.resourceTypes,
                isSelected: currentResourceNames.includes(resource.name),
                availableClass: ''
            }));

            const activityResourceTypes = ($scope.appointment.activities || [])
                .flatMap(a => {
                    const appointmentType = appContext.appointmentTypes.find(t => t.id === a.id);
                    return (appointmentType && appointmentType.resourceTypes) ? appointmentType.resourceTypes : [];
                });

            const sortByName = (a, b) => a.name.localeCompare(b.name);
            const isCorrelated = resource => resource.resourceTypes &&
                resource.resourceTypes.some(type => activityResourceTypes.includes(type));

            $scope.correlatedPickableResources = $scope.pickableResources.filter(isCorrelated).sort(sortByName);
            $scope.otherPickableResources = $scope.pickableResources.filter(r => !isCorrelated(r)).sort(sortByName);

            Resources.getDayAvailability($scope.appointment.day).then(availabilities => {
                const start = doclrStaticUtils.toMinutes($scope.appointment.from);
                const end = doclrStaticUtils.toMinutes($scope.appointment.until);

                $scope.pickableResources.forEach(resource => {
                    const resourceAvailability = availabilities.find(a => a.resourceId === resource.id);
                    if (!resourceAvailability || !resourceAvailability.unAvailablePeriods) {
                        resource.availableClass = 'status-nok';
                        return;
                    }
                    const unavailableForDay = resourceAvailability.unAvailablePeriods[$scope.appointment.day];
                    if (!unavailableForDay) {
                        resource.availableClass = 'status-ok';
                        return;
                    }
                    const isOccupied = unavailableForDay.some(period => {
                        if (start < period.start) {
                            return !(end <= period.start || period.end <= start);
                        }
                        return !(period.end <= start || end <= period.start);
                    });
                    resource.availableClass = isOccupied ? 'status-nok' : 'status-ok';
                });
            });

            $scope.isEditResources = true;
        };

        $scope.cancelBenodigdheden = function () {
            $scope.isEditResources = false;
        };

        $scope.saveBenodigdheden = function () {
            const hasOccupiedSelected = $scope.pickableResources.some(r => r.isSelected && r.availableClass === 'status-nok');
            if (hasOccupiedSelected) {
                DoclrModalService.openConfirmModal(
                    'Benodigdheid al bezet',
                    'Een of meer geselecteerde benodigdheden zijn bezet voor dit tijdstip. Wil je toch verdergaan?'
                ).then(() => doSaveBenodigdheden()).catch(angular.noop);
                return;
            }


            const selectedResourceIds = $scope.pickableResources
                .filter(r => r.isSelected)
                .map(r => r.id);

            if (selectedResourceIds.length) {
                Resources.checkResourceConflict($scope.appointment.day, $scope.appointment.from, $scope.appointment.until, selectedResourceIds, $scope.appointmentId)
                    .then(result => {
                        if (result && result.conflictingResources && result.conflictingResources.length > 0) {
                            result.conflictingResources.forEach(id => {
                                const resource = $scope.pickableResources.find(r => r.id === id);
                                if (resource) resource.availableClass = 'status-nok';
                            });
                            DoclrModalService.openConfirmModal(
                                'Benodigdheid al bezet',
                                'Een of meer geselecteerde benodigdheden zijn bezet voor dit tijdstip. Wil je toch verdergaan?'
                            ).then(() => doSaveBenodigdheden()).catch(angular.noop);
                            return;
                        }
                        doSaveBenodigdheden();
                    }).catch(angular.noop);
                return;
            }

            doSaveBenodigdheden();
        };

        function doSaveBenodigdheden() {
            const selectedResources = $scope.pickableResources
                .filter(r => r.isSelected)
                .map(r => ({resourceId: r.id, resourceName: r.name}));

            $scope.loadingData = true;
            DoclrHttp.put(appointmentUrl + '/update-resources', selectedResources)
                .then(() => notificationService.showSuccess('Benodigdheid gewijzigd'))
                .then(() => DoclrHttp.get(appointmentUrl))
                .then(appointment => appointmentLoaded(appointment))
                .then(() => slicesService.reload())
                .then(() => {
                    $scope.isEditResources = false;
                })
                .catch(() => {
                    $scope.loadingData = false;
                });
        }

        $scope.$watch('appointment.duration', function (newValue, oldValue) {
            if (!$scope.isEditDuration || newValue === oldValue) {
                return;
            }

            if (!newValue) {
                return
            }

            const vanUur = moment($scope.appointment.from, 'HH:mm');
            $scope.appointment.until = vanUur.add(newValue, 'minutes').format('HH:mm');
        });


        $scope.changeActivity = function (activity) {
            //     if ($scope.availableTypes < 2) {
            //         return;
            //     }

            $scope.selectingActivity = activity;

            $scope.selectedType = undefined;

            focusSearchboxActivity();
        }

        $scope.addPersonToActivity = function (activity) {
            if (activity.numberOfPersons < 9) {
                activity.numberOfPersons = activity.numberOfPersons + 1;
                recalculateLength();
            }
        }

        $scope.removePersonFromActivity = function (activity) {
            if (activity.numberOfPersons > 1) {
                activity.numberOfPersons = activity.numberOfPersons - 1;
                recalculateLength();
            }
        }

        function focusSearchboxActivity() {
            window.setTimeout(x => {
                    const searchboxActivity = document.getElementById("searchboxActivity");
                    if (searchboxActivity) {
                        searchboxActivity.focus();
                    }
                }, 20
            );
        }

        $scope.selectOnSearch = function (type) {

            let isNewActivity = !$scope.selectingActivity.id;
            let activity = $scope.selectingActivity;

            $scope.selectingActivity.id = type.id;
            $scope.selectingActivity = undefined;

            if (isNewActivity) {
                $scope.activities.push(activity);
            }

            loadCustomForm($scope.activities.map(x => x.id));
            recalculateLength();
            filterAvailableProducts();
        }

        function recalculateLength() {
            const duration = $scope.activities.map(acc => {
                const appointmentType = doclrUtilsList.getFirst(appContext.appointmentTypes.filter(x => x.id === acc.id));
                return appointmentType.duration + (appointmentType.durationExtra ? (appointmentType.durationExtra * (acc.numberOfPersons - 1)) : 0);
            }).reduce((a, b) => a + b, 0);

            $scope.appointment.duration = duration;

            const vanUur = moment($scope.appointment.from, 'HH:mm');
            $scope.appointment.until = vanUur.add(duration, 'minutes').format('HH:mm');

        }


        $scope.cancelChangeActivity = function () {
            $scope.selectingActivity = undefined;
        }

        $scope.removeActivity = function (activity) {
            $scope.activities = $scope.activities.filter(x => x.id !== activity.id);
        }

        $scope.addActivity = function () {
            $scope.selectingActivity = {
                numberOfPersons: 1
            };

            focusSearchboxActivity();
        }

        function loadCalendar() {
            const possibleCalendars = calendars.filter(x => x.uuid === $scope.appointment.calendarId);
            if (possibleCalendars.length > 0) {
                $scope.calendar = possibleCalendars[0];


                BeschikbaarheidTypes.getTypes(praktijkContext.id).then(beschikbaarheidTypes => {
                    //TODO: Filter on relation
                    const filteredTypes = beschikbaarheidTypes
                        .filter(type => type.event_type === "afspraakMogelijkheid")
                        .filter(type => $scope.calendar.disciplineName === type.disciplineName)
                        .filter(type => type.isActive);

                    $scope.availableProducts = localStorageService.sortTypesByLocalStorage(filteredTypes, 'appointment_create', doclrStaticUtils.getUUIDFromObjectWithId($scope.calendar));
                    filterAvailableProducts();
                })

            }
        }

        function filterAvailableProducts() {
            if ($scope.activities) {
                $scope.filteredProducts = $scope.availableProducts
                    .filter(pr => $scope.activities.filter(act => act.id === pr.id).length === 0);
            }
        }

        function loadActivities() {
            if (!$scope.appointment.activities) {
                return;
            }

            $scope.activities =
                $scope.appointment.activities.map(a => {
                    return {
                        numberOfPersons: a.numberOfPersons,
                        id: a.id
                    };
                });

            const activityTexts = $scope.appointment.activities.map(a => getActivityText(a));

            $scope.activityInfo = {
                multiple: $scope.appointment.activities.length > 1,
                activityTexts: activityTexts
            };

        }

        DoclrHttp.get(appointmentUrl)
            .then(appointment => appointmentLoaded(appointment))
    }

    function getActivityText(activity) {
        let singleActivityText = "";
        if (activity.numberOfPersons > 1) {
            singleActivityText = activity.numberOfPersons + "x ";
        }
        singleActivityText = singleActivityText + doclrVertaal.translateTypeById(activity.id);
        return singleActivityText;
    }


    return {
        openAppointmentPopup: openAppointmentPopup
    };
});